export const UPDATE_ADMIN_QUESTION_REQUEST = " UPDATE_ADMIN_QUESTION_REQUEST";
export const UPDATE_ADMIN_QUESTION_SUCCESS = " UPDATE_ADMIN_QUESTION_SUCCESS";
export const UPDATE_ADMIN_QUESTION_FAILURE = " UPDATE_ADMIN_QUESTION_FAILURE";
